
import { Vue, Component, Prop } from 'vue-property-decorator'
import User from '@/types/user'
import Feedback, { WoononApps } from '@/types/feedback'
import axios from 'axios'
import TextEditor from '@/components/base/TextEditor.vue'
import Uploader from '@/components/media/Uploader.vue'
import UploadQueue from '@/components/media/UploadQueue.vue'
import ls from '@/ls'

@Component({
  components: { UploadQueue, Uploader, TextEditor }
})

export default class FeedbackCreate extends Vue {
  @Prop() parentId!:number|null

  settings = {
    routeNames: { list: 'feedbacks', show: 'feedbackShow', edit: 'feedbackEdit' },
    routeParamKey: 'feedbackId',
    functionNames: { setCurrent: 'setCurrentFeedback', clearCurrent: 'clearCurrentFeedback', save: 'saveFeedback' },
    getterNames: { current: 'currentFeedback', loading: 'loadingFeedback' }
  }

  currentTab:string = ls.get('feedbackEditActiveTab') || 'details'

  employees:User[] = []
  woononApps = WoononApps

  categories:{ id:number, name:string, slug:string }[] = []

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
    this.getCategories()
    if (this.parentId) {
      this.currentItem.parent_id = this.parentId
    }
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  getCategories () : void {
    axios.get(process.env.VUE_APP_API_URL + '/feedbacks/categories').then((res) => {
      this.categories = res.data
    })
  }

  get sortedCategories (): { id:number, name:string, slug:string }[] {
    return this.categories.sort((a: { name: string }, b: { name: string }) => { return a.name.localeCompare(b.name) })
  }

  newFileUploaded (file:File) : void {
    this.currentItem.files.push(file)
  }

  fileDeleted (index:number) : void {
    this.currentItem.files.splice(index, 1)
  }

  setActiveTab (tab:string) : void {
    ls.set('feedbackEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, id:number|undefined) : void {
    if (id) {
      this.$router.push({ name: routeName, params: { [this.settings.routeParamKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : Feedback {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
